import { render, staticRenderFns } from "./delete-btn.vue?vue&type=template&id=68e2b7af&"
import script from "./delete-btn.vue?vue&type=script&lang=ts&"
export * from "./delete-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports